import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api'

// Что плавает внизу экрана поверх страницы: плашка про cookie, кнопка чата
// Chaport и его приветствие («Здравствуйте! Есть вопрос по заявке?»). На
// телефоне они вместе закрывали треть экрана, и последние кнопки страницы — в
// заявке «Отправить» — оставались под ними: прокрутить выше было некуда (отзыв
// 07.10.2026: «с мобильного телефона невозможно сделать заявку»). Меряем,
// сколько места снизу занято, и даём странице столько же места для прокрутки.
const FLOATING = ['.cookie-notice .v-snack__wrapper', '.chaport-launcher-button', '.chaport-message']

// Между последней кнопкой и плавающим — небольшой зазор.
const GAP = 16

// Чат — чужой виджет: приветствие показывает и прячет сам, нам о том не
// сообщает. Поэтому перемеряем раз в секунду (дёшево: три элемента), а ещё при
// прокрутке и смене размера окна.
const POLL_MS = 1000

const isShown = element => {
  const style = window.getComputedStyle(element)

  return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.1
}

// Сколько пикселей от нижнего края экрана занято плавающим.
const coveredHeight = () => {
  let top = window.innerHeight
  FLOATING.forEach(selector => {
    document.querySelectorAll(selector).forEach(element => {
      if (!isShown(element)) return
      const rect = element.getBoundingClientRect()
      if (rect.height > 0 && rect.top < top) top = rect.top
    })
  })

  return Math.max(0, window.innerHeight - top)
}

// Возвращает ref на распорку (пустой блок в конце страницы) и её высоту.
// Под распоркой и так есть место — подвал кабинета; распорка добирает
// недостающее, чтобы последнюю кнопку можно было вытянуть над плавающим.
export default function useFloatingClearance() {
  const spacer = ref(null)
  const height = ref(0)
  let timer = null
  let frame = null

  const measure = () => {
    frame = null
    const element = spacer.value
    if (!element) return
    const below = document.documentElement.scrollHeight - (element.getBoundingClientRect().bottom + window.scrollY)
    height.value = Math.max(0, Math.ceil(coveredHeight() + GAP - below))
  }
  const schedule = () => {
    if (frame === null) frame = window.requestAnimationFrame(measure)
  }

  onMounted(() => {
    schedule()
    timer = window.setInterval(schedule, POLL_MS)
    window.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule, { passive: true })
  })
  onBeforeUnmount(() => {
    window.clearInterval(timer)
    if (frame !== null) window.cancelAnimationFrame(frame)
    window.removeEventListener('scroll', schedule)
    window.removeEventListener('resize', schedule)
  })

  return { spacer, height }
}
